
<template>
  <div class="orderClassify2">
    <div class="orderClassifyLeft">
      <div class="orderClassifyLeftTitle" @click="tabVisible=true">
        一览表
        <!-- <img @click="remove" src="@/assets/images/common/icon_delete.png" />
              <img @click="amendItem" src="@/assets/images/common/icon_modify.png" />
        <img @click="append" src="@/assets/images/common/icon_add.png" />-->
      </div>
      <div class="custom-tree-container">
        <div class="block">
          <el-tree
            :data="ProjectDateTree"
            node-key="id"
            default-expand-all
            :expand-on-click-node="false"
            :props="defaultProps"
            @node-click="handleNodeClick"
            highlight-current
            lazy
          >
            <span class="custom-tree-node" slot-scope="{node}">
              <!-- <img class="treeNodeIcon" src="@/assets/images/common/icon_tree_node.png" /> -->
              <span>{{ node.label }}</span>
            </span>
          </el-tree>
        </div>
      </div>
    </div>
    <!--财务分类 一览表 -->
    <div class="orderClassifyRight" v-show="tabVisible">
      <div class="classifyRightItem">
        <div class="rightItemTitle">总包合同</div>
        <el-input
          class="rightItemInput"
          placeholder="总包合同"
          v-model="generalContractName"
          :disabled="true"
        ></el-input>
      </div>
      <div class="classifyRightItem">
        <div class="rightItemTitle">项目名称</div>
        <el-input class="rightItemInput" placeholder="项目名称" v-model="name" :disabled="true"></el-input>
      </div>
      <div class="classifyRightItem">
        <div class="rightItemTitle">项目类型</div>
        <el-input
          class="rightItemInput"
          placeholder="项目类型"
          v-model="projectTypeName"
          :disabled="true"
        ></el-input>
      </div>
      <div class="classifyRightItem">
        <div class="rightItemTitle">总包金额</div>
        <el-input
          class="rightItemInput"
          placeholder="12"
          v-model="generalContractAmount"
          :disabled="true"
        ></el-input>
      </div>

      <!--右侧一览表表格数据  -->
      <el-table ref="multipleTable" :data="generaltableData" border size="mini" style="width: 80%">
        <!-- <el-table-column type="selection" width="50"></el-table-column> -->
        <el-table-column type="index" width="100" label="序号"></el-table-column>
        <el-table-column
          v-for="(item,index) in generltableColumn"
          :key="index"
          :prop="item.class"
          :label="item.labelName"
          :sortable="item.sortEnable"
          show-overflow-tooltip
        >
          <template slot-scope="scope">     
          <span v-if="item.isNumFilter">{{scope.row[scope.column.property]|numFilter}}</span>     
          <span v-else>{{scope.row[scope.column.property]}}</span>
         </template></el-table-column>
      </el-table>
    </div>

    <!--工程分类 子分类表  -->
    <div class="orderClassifyRight" v-show="!tabVisible">
      <!--右侧表格数据  -->
      <el-table
        ref="multipleTable"
        :data="subtableData"
        border
        size="mini"
        style="width: 90%"
        height="100%"
        @cell-dblclick="projectDetail"
      >
        <el-table-column type="index" width="100" label="序号"></el-table-column>
        <el-table-column
          v-for="(item,index) in subtableColumnDatas"
          :key="index"
          :prop="item.class"
          :label="item.labelName"
          :sortable="item.sortEnable"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="item.isNumFilter">{{scope.row[scope.column.property]|numFilter}}</span>
            <span v-else>{{scope.row[scope.column.property]}}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="total">
        <span>总包合计：{{genneralTotal}}</span>
        <span>分包合计：{{subTotal}}</span>
        <span>毛利：{{profit}}</span>
      </div>
    </div>

    <!-- 工程分类子目明细 -->
    <el-dialog class="dialog816" title="子目明细" :visible.sync="isDialogShow">
      <el-table
        ref="multipleTable"
        :data="subtableDataDetail"
        border
        size="mini"
        style="width: 90%"
        :close-on-click-modal="false"
      >
        <el-table-column type="index" width="100" label="序号"></el-table-column>
        <el-table-column
          v-for="(item,index) in subtableColumnDatasDetail"
          :key="index"
          :prop="item.class"
          :label="item.labelName"
          :sortable="item.sortEnable"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="item.isNumFilter">{{scope.row[scope.column.property]|numFilter}}</span>
            <span v-else>{{scope.row[scope.column.property]}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button @click="subClassDetail(scope.row)" type="text" size="small">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="isDialogShow=false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getBasicDataListService, //获取财务、工程分类数据字典数据
  getProjectOverAllService, //获取工程分类总览数据
  getProjectTypeDetailService, //获取工程分类章节数据
  getProjectsubDetailService //获取工程分类章节子目数据
} from "@/services/allContractServices";
import {
  BasicDataTwoDetailsService //获取二级数据字典内容
} from "@/services/sysSettingService";
import { numFilter } from "@/utils/filters";
export default {
  name: "projectList",
  props: {
    generalContractName: {
      type: String,
      default: ""
    },
    projectId: {
      type: Number,
      default: 0
    },
    name: {
      type: String,
      default: ""
    },
    projectTypeName: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      category: "SUBPROJECTTYPE", //分项合同工程类型
      ProjectDateTree: [], //工程分类列表
      generaltableData: [], //财务一览表表格数据
      subtableData: [], //子分类表格数据
      subtableDataDetail: [], //子表格某一行数据明细
      tabVisible: true,
      generalContractAmount: 0, //总包合同总金额

      generltableColumn: [
        {
          class: "typeKey",
          labelName: "章次",
          sortEnable: false,
          width: 300
        },
        {
          class: "typeName",
          labelName: "科目名称",
          sortEnable: false
        },
        {
          class: "typeValue",
          labelName: "金额",
          sortEnable: false,
          width: 160,
          isNumFilter: true
        }
      ],
      subtableColumnDatas: [
        {
          class: "subCategoryNo",
          labelName: "细目号",
          sortEnable: false,
          width: 300
        },
        {
          class: "subCategoryName",
          labelName: "细目名称",
          sortEnable: false,
          width: 300
        },
        {
          class: "unit",
          labelName: "单位",
          sortEnable: false,
          width: 300
        },
        {
          class: "budgetQuantity",
          labelName: "数量",
          sortEnable: false,
          width: 300
        },
        {
          class: "budgetUnitPrice",
          labelName: "单价",
          sortEnable: false,
          width: 300,
          isNumFilter: true
        },
        {
          class: "budgetTotalPrice",
          labelName: "合计",
          sortEnable: false,
          width: 160,
          isNumFilter: true
        },
        {
          class: "actualQuantity",
          labelName: "分包数量",
          sortEnable: false,
          width: 300
        },
        {
          class: "actualUnitPrice",
          labelName: "分包单价",
          sortEnable: false,
          width: 300,
          isNumFilter: true
        },
        {
          class: "actualTotalPrice",
          labelName: "分包金额",
          sortEnable: false,
          width: 300,
          isNumFilter: true
        },
        {
          class: "profit",
          labelName: "合同毛利",
          sortEnable: false,
          width: 160,
          isNumFilter: true
        }
      ],
      subtableColumnDatasDetail: [
        {
          class: "partyBName",
          labelName: "合作单位",
          sortEnable: false,
          width: 300
        },
        {
          class: "quantity",
          labelName: "分包数量",
          sortEnable: false,
          width: 300
        },
        {
          class: "unitPrice",
          labelName: "分包单价",
          sortEnable: false,
          width: 300,
          isNumFilter: true
        },
        {
          class: "totalPrice",
          labelName: "分包金额",
          sortEnable: false,
          width: 300,
          isNumFilter: true
        }
      ],
      defaultProps: {
        children: "children",
        label: "label",
        id: "id",
        isLeaf: "leaf"
      },
      selectData: null,

      complCatName: "",
      limitTime: "",
      genneralTotal: 0, //总包合计
      subTotal: 0, //分包合计
      profit: 0, //毛利
      isDialogShow: false, //弹出框可见性
      activeName: "first"
    };
  },
  watch: {
    projectId(newVal) {
      // this.projectId=newVal;
      if (newVal !== undefined || newVal !== null) {
        this.getProjectOverAllData();
      }

      //  this.$set(this.projectId);
    }
  },
  created() {
    this.getProjectTypeCode(this.category); //获取工程数据
  },
  methods: {
    onActive(menuCode) {
      // this.projectId = this.tabRouteParam.id;
      // this.generalContractName = this.tabRouteParam.generalContractName; //总包合同名称
      // this.name = this.tabRouteParam.name; //项目名称
      // this.projectTypeName = this.tabRouteParam.projectTypeName; //项目类型
      this.getProjectOverAllData();
    },
    //获取子目明细table行点击数据
    getProjectsubDetail(subCategoryNo) {
      let param = {};
      param.projectId = this.projectId;
      param.subCategoryNo = subCategoryNo;
      getProjectsubDetailService(param)
        .then(res => {
          if (res.code == 10000000) {
            this.subtableDataDetail = res.data.subContractProjectDetailsVOList;
            // resolve(children);
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch(error => {
          this.$message.error("网络请求失败");
        });
    },
    //获取工程分类tree数据
    getProjectTypeCode(category) {
      let param = {};
      param.category = category;
      getBasicDataListService(param)
        .then(res => {
          if (res.code == 10000000) {
            if (category == "SUBPROJECTTYPE") {
              this.ProjectDateTree = res.data; //工程分类树
            }
          } else {
            if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定"
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定"
              });
            }
          }
        })
        .catch(error => {});
    },
    /* tree点击回调事件 */
    handleNodeClick(deptNode) {
      // this.deptSelected = deptNode;
      // this.departList[this.choiceindex].deptId = deptNode.id;
      this.tabVisible = false;
      this.getProjectSubData(deptNode.label);
    },
    //查看子分类列表一条数据详情 gaa 20200811
    subClassDetail(row) {
      this.$confirm("确定要查看吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let memberData = {};
        memberData.id = row.contractId; //合同编号
        this.bus.$emit("navMenuChange", {
          //跳转相应的分项合同
          routeId: "totalApproveList",
          routeParam: memberData
        });
      });
    },

    //获取工程总览数据
    getProjectOverAllData() {
      let reqParam = {
        projectId: this.projectId
      };
      getProjectOverAllService(reqParam).then(
        res => {
          if (res.code == 10000000) {
            this.generalContractAmount = numFilter(
              res.data.generalContractAmount
            );
            this.generaltableData = res.data.subContractProjectTypesVOList;
            if (
              undefined != this.generaltableData &&
              null != this.generaltableData
            ) {
              let len = this.generaltableData.length;
              this.generaltableData[len] = {};
              this.generaltableData[len].typeName = "第100章到700章清单合计";
              this.generaltableData[len].typeValue = numFilter(
                res.data.subContractAmountTotal
              );
            }
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定"
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定"
            });
          }
        },
        err => {
          this.$alert(err, "提示", {
            confirmButtonText: "确定"
          });
        }
      );
    },

    //获取工程分类子类数据
    getProjectSubData(chapter) {
      let reqParam = {
        projectId: this.projectId,
        chapter: chapter
      };
      getProjectTypeDetailService(reqParam).then(
        res => {
          if (res.code == 10000000) {
            this.subtableData = res.data.projectDetailsList;
            this.genneralTotal = numFilter(res.data.genneralTotal);
            this.subTotal = numFilter(res.data.subTotal);
            this.profit = numFilter(res.data.profit);
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定"
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定"
            });
          }
        },
        err => {
          this.$alert(err, "提示", {
            confirmButtonText: "确定"
          });
        }
      );
    },
    //双击某行展示明细
    projectDetail(row, column, cell, event) {
      this.isDialogShow = true;
      this.getProjectsubDetail(row.subCategoryNo);
    },
    closeBtn() {
      if (this.$refs.addForm) {
        this.addForm = {
          addComplCatName: "",
          addLimitTime: ""
        };
        this.$refs.addForm.resetFields();
      }
      this.isShowMaskBol = false;
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";
.orderClassify2 {
  height: 100%;
  display: flex;
  justify-content: space-between;
  /deep/.el-tabs__header {
    padding-right: 0;
    background: #d5e7ed;
    .is-active {
      background: #ffffff;
    }
  }
  /deep/.el-tabs__content {
    height: calc(100% - 40px);
  }
}
.orderClassifyLeft {
  height: 100%;
  width: 350px;
  padding: 24px;
  background: #fff;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  .orderClassifyLeftTitle {
    text-align: left;
    font-family: PingFangSC-Medium;
    font-size: 18px;
    color: #333333;
    letter-spacing: 0;
    line-height: 18px;
    font-weight: 600;
    margin-bottom: 16px;
    img {
      vertical-align: middle;
      float: right;
      margin: 5px 8px 0 0;
    }
  }

  .custom-tree-container {
    min-width: 302px;
    height: 800px;
    overflow: auto;
    padding-top: 18px;
    padding-left: 12px;
    box-sizing: border-box;
    margin: 0 auto;
    background: #f0f5f7;

    /deep/ .el-tree {
      background: none;
    }

    .custom-tree-node {
      //   width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .classifyBtn {
        width: 14px;
        height: 14px;
      }
      .lastclassifyBtn {
        margin-right: 16px;
      }
    }
  }
}
.orderClassifyRight {
  width: calc(100% - 340px);
  /*width: 100%;*/
  /*height: 500px;*/
  background: #fff;
  margin-left: 16px;
  margin-top: 20px;
  padding: 24px;
  box-sizing: border-box;
  .classifyRightItem {
    display: flex;
    align-items: center;
    padding-bottom: 20px;
    .rightItemTitle {
      width: 125px;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #333333;
      letter-spacing: 0;
      text-align: right;
      line-height: 14px;
    }
    .rightItemInput {
      width: 280px;
      height: 36px;
      margin-left: 16px;
    }
  }
  .classifyRightItem:last-child {
    margin-top: 16px;
  }
}

.total span {
  font-size: 18px;
  padding-left: 20px;
}
</style>
